import toast from 'react-hot-toast';
import axios from 'axios';
const baseURL=  process.env.REACT_APP_BASE_URL


//   AWS.config.update({
//     accessKeyId: "AKIAQ3EGWBDCAQYL4TRU",
//     secretAccessKey: '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'
//   });




//     return result.Location // Return the file URL
//   } catch (error) {
//     throw new Error("Error uploading file: " + error.message);
//   }
// };


export const uploadFileToS3 = async (file, setUploadPercent) => {
  const API_URL = '/content/file';
  const formData = new FormData();
  formData.append('image', file); // Changed the key to 'video'

  try {
    const response = await axios.post(`${baseURL}${API_URL}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      onUploadProgress: (progressEvent) => {
        if (setUploadPercent) {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadPercent(percentCompleted); // Update upload progress
        }
      },
    });

    if (response.data.statusCode === 200) {
      return response.data;
    }
  } catch (error) {
    console.error('Error uploading content:', error.response?.data || error.message);
    throw error; // Re-throw the error to handle it in the calling function
  }
};


//   AWS.config.update({
//     accessKeyId: "AKIAQ3EGWBDCAQYL4TRU",
//     secretAccessKey: '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'
//   });










export const uploadVideoToS3 = async (file, setUploadPercent, setFieldValue, MobileURL) => {
  const API_URL = '/content/upload';
  const formData = new FormData();
  formData.append('video', file); // Changed the key to 'video'

  try {
    const response = await axios.post(`${baseURL}${API_URL}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      onUploadProgress: (progressEvent) => {
        if (setUploadPercent) {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadPercent(percentCompleted); // Update upload progress
        }
      },
    });

    if (response.data.statusCode === 200) {
      // Update MobileURL or setFieldValue if applicable
        setFieldValue(MobileURL, response.data.data.streaming_url); // Assuming `fileUrl` is returned
      return response.data;
    }
  } catch (error) {
    console.error('Error uploading content:', error.response?.data || error.message);
    throw error; // Re-throw the error to handle it in the calling function
  }
};





export const formatDuration = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
};






export const truncateText = (text, wordLimit) => {
  if (!text) return 'N/A';
  const words = text.split(' ');
  if (words.length > wordLimit) {
    return words.slice(0, wordLimit).join(' ') + '...';
  }
  return text;
};


export const truncateTextManageContent = (text, wordLimit, charLimit = 30) => {
  if (!text) return 'N/A';
  
  const words = text.split(' ');
  let truncated = words.slice(0, wordLimit).join(' ');

  // If after slicing it is still too long (like because of a long URL)
  if (truncated.length > charLimit) {
    truncated = truncated.substring(0, charLimit) + '...';
  }

  return truncated;
};











//             return record;
//           });

//           resolve(data);
//         } else {
//           reject(new Error(`Missing required headers: ${requiredKeys.join(', ')}`));
//         }
//       } else {
//         reject(new Error('No data found in the CSV'));
//       }
//     };


//     reader.readAsText(file);
//   });
// };



export const uploadStudentCSV = async (file) => {
  const reader = new FileReader();
  const requiredKeys = ['firstname', 'surname', 'username', 'email', 'year' ];

  return new Promise((resolve, reject) => {
    reader.onload = function (e) {
      const text = e.target.result;

      const delimiters = [',', ';', '\t'];
      let delimiter = ',';
      let maxCount = 0;

      // Detect the correct delimiter
      delimiters.forEach((d) => {
        const count = (text.split('\n')[0].match(new RegExp(d, 'g')) || []).length;
        if (count > maxCount) {
          maxCount = count;
          delimiter = d;
        }
      });

      const lines = text.split('\n').filter(Boolean);

      if (lines.length > 1) {
        const headers = lines[0]
          .split(delimiter)
          .map((header) => header.trim().toLowerCase().replace(/^"|"$/g, '')); // Remove surrounding quotes
        // Debugging outputs

        const hasRequiredHeaders = requiredKeys.every((key) => headers.includes(key));

        if (hasRequiredHeaders) {
          const data = [];
          const usernameCount = {}; // Object to track how many times a username has been used

          for (let i = 1; i < lines.length; i++) {
            const values = lines[i].split(delimiter).map((value) => value.trim().replace(/^"|"$/g, '')); // Remove quotes from values
            const record = {};

            headers.forEach((header, index) => {
              if (requiredKeys.includes(header)) {
                record[header] = values[index];
              }
            });

            if (record.year) {
              const year = parseInt(record.year, 10);
              if ([7, 8, 9].includes(year)) {
                record.group = 3;
              } else if ([10, 11, 12].includes(year)) {
                record.group = 4;
              }
            }

            // Handle both user-provided and auto-generated usernames
            let baseUsername;
            if (record.username) {
              baseUsername = record.username.toLowerCase().replace(/[^a-z0-9]/gi, '');
            } else if (record.firstname && record.surname) {
              baseUsername = `${record.firstname}${record.surname}`.toLowerCase().replace(/[^a-z0-9]/gi, '');
            }

            if (baseUsername && baseUsername.length > 15) {
              baseUsername = baseUsername.substring(0, 15); // Maximum username length
            }

            if (baseUsername) {
              let newUsername = baseUsername;

              if (usernameCount[baseUsername]) {
                usernameCount[baseUsername]++;
                newUsername = `${baseUsername}${usernameCount[baseUsername]}`;
              } else {
                usernameCount[baseUsername] = 1;
              }

              record.username = newUsername;
            }

            if (!record.email) {
              toast.error(`One of the records is missing an email.`);
              resolve([]);
              return;
            }

            data.push(record);
          }

          resolve(data);
        } else {
          const missingHeaders = requiredKeys.filter((key) => !headers.includes(key));
          reject(new Error(`Missing required headers: ${missingHeaders.join(', ')}`));
        }
      } else {
        reject(new Error('No data found in the CSV'));
      }
    };

    reader.onerror = () => {
      reject(new Error('Failed to read file'));
    };

    reader.readAsText(file);
  });
};

export const uploadTeacherCSV = async (file) => {
  const reader = new FileReader();
  const requiredKeys = ['firstname', 'surname', 'email', 'department'];

  return new Promise((resolve, reject) => {
    reader.onload = function (e) {
      let text = e.target.result;

      // Remove BOM and normalize line endings
      text = text.replace(/^\uFEFF/, '').replace(/\r\n/g, '\n');

      // Detect delimiter
      const delimiters = [',', ';', '\t'];
      const delimiter = delimiters.find((d) => text.includes(d)) || ',';

      const lines = text.split('\n').map((line) => line.trim()).filter(Boolean);

      if (lines.length > 1) {
        const headers = lines[0]
          .split(delimiter)
          .map((header) =>
            header.trim().toLowerCase().replace(/^"|"$/g, '') // Strip quotes
          );

        const hasRequiredHeaders = requiredKeys.every((key) => headers.includes(key));

        if (!hasRequiredHeaders) {
          toast.error(`Missing required headers: ${requiredKeys.join(', ')}`);
          resolve([]);
          return;
        }

        const data = [];

        for (let i = 1; i < lines.length; i++) {
          const values = lines[i]
            .split(delimiter)
            .map((value) => value.trim().replace(/^"|"$/g, '')); // Also strip quotes from values

          if (values.length !== headers.length) continue; // Skip malformed rows

          const record = {};
          headers.forEach((header, index) => {
            if (requiredKeys.includes(header)) {
              record[header] = values[index];
            }
          });

          if (!record.email) {
            toast.error(`Record on line ${i + 1} is missing an email.`);
            resolve([]);
            return;
          }

          data.push(record);
        }

        resolve(data);
      } else {
        toast.error('No data found in the CSV');
        resolve([]);
      }
    };

    reader.onerror = () => {
      toast.error('Failed to read file');
      reject(new Error('Failed to read file'));
    };

    reader.readAsText(file);
  });
};



export function convertTime(minutes) {
  const hours = Math.floor(minutes / 60);  // Get the hours
  const remainingMinutes = minutes % 60;   // Get the remaining minutes

  if (hours > 0 && remainingMinutes > 0) {
    return `${hours}h ${remainingMinutes}m`;  // "Xh Ym"
  } else if (hours > 0) {
    return `${hours}h`;  // Only hours
  } else {
    return `${remainingMinutes}m`;  // Only minutes
  }
}

export const constructQueryString = (obj) => {
  if (obj) {
    const queryString = Object.keys(obj)
      .filter(key => obj[key] !== "" && obj[key] !== null && obj[key] !== undefined)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
      .join('&');
    return queryString;
  } else {
    return ""
  }
}

const normalizeRoute = (route = "") => {
  let cleaned = `${route}`.replace(/^\/+/, "");
  const routeMap = {
    ManageSchools: "manage-schools",
    Students: "students",
    Teachers: "teachers",
    Parents: "parents",
    Workers: "workers",
    Support: "support",
    ManageContent: "manage-content",
    ManageAdmins: "manage-admins",
    ManageCategories: "manage-categories",
    ManageOrganisationGroups: "manage-organisation-groups",
    PushNotifications: "push-notifications",
  };
  if (routeMap[cleaned]) {
    cleaned = routeMap[cleaned];
  }
  cleaned = cleaned.replace(/^SchoolProfile(?=\/|$)/i, "school-profile");
  cleaned = cleaned.replace(/^StudentProfile(?=\/|$)/i, "student-profile");
  cleaned = cleaned.replace(/^TeacherProfile(?=\/|$)/i, "teacher-profile");
  cleaned = cleaned.replace(/^ParentProfile(?=\/|$)/i, "parent-profile");
  cleaned = cleaned.replace(/^WorkerProfile(?=\/|$)/i, "worker-profile");
  cleaned = cleaned.replace(/^SchoolAdminProfile(?=\/|$)/i, "school-admin-profile");
  return cleaned;
};

export const buildDetailNavigationPath = ({
  detailPath,
  returnRoute,
  currentSearch = "",
  currentPage = 1,
}) => {
  const queryParams = new URLSearchParams();
  const normalizedRoute = normalizeRoute(returnRoute);
  const normalizedSearch = `${currentSearch || ""}`.replace(/^\?/, "");

  queryParams.set("returnPage", `${currentPage}`);

  if (normalizedRoute) {
    queryParams.set("returnRoute", normalizedRoute);
  }

  if (normalizedSearch) {
    queryParams.set("returnQuery", normalizedSearch);
  }

  return `${detailPath}?${queryParams.toString()}`;
};

export const resolveReturnUrl = ({
  search = "",
  fallbackRoute = "",
  fallbackPage = "1",
}) => {
  const queryParams = new URLSearchParams(search);
  const returnPage = queryParams.get("returnPage") || `${fallbackPage}`;
  const returnRoute = normalizeRoute(
    queryParams.get("returnRoute") || fallbackRoute,
  );
  const returnQuery = queryParams.get("returnQuery") || "";

  if (returnQuery && returnRoute) {
    return `/${returnRoute}?${returnQuery}`;
  }

  if (returnRoute && returnRoute.includes("/")) {
    return `/${returnRoute}`;
  }

  if (returnRoute) {
    return `/${returnRoute}?page=${returnPage}`;
  }

  return `?page=${returnPage}`;
};

const statusCountKeys = {
  Active: ["active"],
  Inactive: ["inActive", "inactive"],
  Created: ["created", "Created"],
  Blocked: ["blocked", "Blocked"],
};

export const getFilteredPaginationTotal = ({
  response,
  rows = [],
  status = "",
  currentPage = 0,
  hasFilters = false,
  fallbackKey = "total",
}) => {
  const matchedStatusKeys = statusCountKeys[status] || [];

  for (const key of matchedStatusKeys) {
    const totalForStatus = Number(response?.[key]);
    if (Number.isFinite(totalForStatus)) {
      return totalForStatus;
    }
  }

  if (
    hasFilters &&
    currentPage === 0 &&
    Array.isArray(rows) &&
    rows.length === 0
  ) {
    return 0;
  }

  const fallbackTotal = Number(response?.[fallbackKey]);
  if (Number.isFinite(fallbackTotal)) {
    return fallbackTotal;
  }

  return Array.isArray(rows) ? rows.length : 0;
};




 // Function to filter records based on the specified fields
  export const filteredRecords = (records , fieldsToExport) => {
  return records.map(record => {
    const filteredRecord = {};
    fieldsToExport.forEach(field => {
      filteredRecord[field] = record[field]; // Only include selected fields
    });
    return filteredRecord;
  });
};






export const getQueryParams = (search) => {
  const params = new URLSearchParams(search);
  const queryObject = {
    school :"",
     Year :"",
      group:"" , 
      sortKey:"",
     sortOrder:"",
    selectedCategory:"" ,
    mostViewed:"",
    mostLiked :"",
    dateFormat:"",
    searchkey:"",
    searchKey:"",
    status:"",
    manager:"",
    check:"",
    startDate:"",
    endDate:"",
    returnQuery:"",
    gender:"",
    user:"",
    presenterId:"",
    sortBy:""
  };
  for (const [key, value] of params.entries()) {
    queryObject[key] = value ?? ""; // Ensures empty string for missing values
  }
  return queryObject;
};


export const serialNumber = (currentPage, limit, index) => {
  return (currentPage - 1) * limit + index + 1;
};



export const capitalizeFirstLetter = (str) => {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const getYearGroupDisplay = (student) => {
  if (!student) return null;
  const { year, group } = student;
  const groupVal =
    group !== undefined && group !== null ? String(group).toLowerCase().trim() : "";
  const strYear =
    year !== undefined && year !== null ? String(year).toLowerCase().trim() : "";

  // College formatting: College (1st Year) / College (2nd Year)
  if (
    groupVal === "14" ||
    groupVal.includes("college") ||
    ["14", "15"].includes(strYear)
  ) {
    if (strYear === "14" || strYear === "12") return "College (1st Year)";
    if (strYear === "15" || strYear === "13") return "College (2nd Year)";
    if (strYear) return `College (Year ${strYear})`;
    return "College";
  }

  // Post-18 formatting
  if (groupVal === "18" || groupVal.includes("post") || strYear === "18") {
    if (strYear && strYear !== "18") {
      return `Year ${strYear} (Post-18)`;
    }
    return "Post-18";
  }

  // All Key Stages formatting
  if (
    groupVal === "16" ||
    groupVal.includes("all key") ||
    strYear === "16" ||
    strYear.includes("all key")
  ) {
    if (strYear && strYear !== "16") {
      return `Year ${strYear} (All Key Stages)`;
    }
    return "All Key Stages";
  }

  // Key Stages groups (KS2 Lower, KS2 Higher, KS3, KS4)
  let groupLabel = "";
  if (groupVal === "1" || groupVal.includes("ks2 lower")) {
    groupLabel = "KS2 Lower";
  } else if (groupVal === "2" || groupVal.includes("ks2 higher")) {
    groupLabel = "KS2 Higher";
  } else if (groupVal === "3" || groupVal === "ks3") {
    groupLabel = "KS3";
  } else if (groupVal === "4" || groupVal === "ks4") {
    groupLabel = "KS4";
  } else if (group) {
    groupLabel = `Group ${group}`;
  }

  // If group wasn't explicitly provided or resolved yet, resolve from year number
  if (!groupLabel) {
    if (["3", "4"].includes(strYear)) {
      groupLabel = "KS2 Lower";
    } else if (["5", "6"].includes(strYear)) {
      groupLabel = "KS2 Higher";
    } else if (["7", "8", "9"].includes(strYear)) {
      groupLabel = "KS3";
    } else if (["10", "11"].includes(strYear)) {
      groupLabel = "KS4";
    } else if (strYear === "12" || strYear === "14") {
      return "College (1st Year)";
    } else if (strYear === "13" || strYear === "15") {
      return "College (2nd Year)";
    }
  }

  if (strYear && groupLabel) {
    return `Year ${strYear} (${groupLabel})`;
  } else if (strYear) {
    return `Year ${strYear}`;
  } else if (groupLabel) {
    return groupLabel;
  }

  return null;
};

export const getStudentListYearGroupDisplay = (student) => {
  if (!student) return null;
  const { year, group } = student;
  const groupVal =
    group !== undefined && group !== null ? String(group).toLowerCase().trim() : "";
  const strYear =
    year !== undefined && year !== null ? String(year).trim() : "";
  const lowerYear = strYear.toLowerCase();

  // 1. College formatting: College (1st year) / College (2nd year)
  if (
    lowerYear === "14" ||
    lowerYear === "12" ||
    lowerYear === "college (1st year)" ||
    lowerYear === "college 1st year" ||
    lowerYear.includes("1st year") ||
    lowerYear.includes("1st")
  ) {
    return "College (1st year)";
  }

  if (
    lowerYear === "15" ||
    lowerYear === "13" ||
    lowerYear === "college (2nd year)" ||
    lowerYear === "college 2nd year" ||
    lowerYear.includes("2nd year") ||
    lowerYear.includes("2nd")
  ) {
    return "College (2nd year)";
  }

  if (groupVal === "14" || groupVal.includes("college")) {
    if (
      lowerYear === "15" ||
      lowerYear === "13" ||
      lowerYear.includes("2nd")
    ) {
      return "College (2nd year)";
    }
    return "College (1st year)";
  }

  // 2. Post-18 formatting
  if (
    lowerYear === "18" ||
    lowerYear.includes("post") ||
    groupVal === "18" ||
    groupVal.includes("post")
  ) {
    return "Post-18";
  }

  // 3. Year 16 / All Key Stages formatting
  if (
    lowerYear === "16" ||
    lowerYear.includes("all key") ||
    groupVal === "16" ||
    groupVal.includes("all key")
  ) {
    return "Year 16";
  }

  // 4. Year 3 to 11 (or any numeric year)
  const numericMatch = strYear.match(/\d+/);
  if (numericMatch) {
    const num = parseInt(numericMatch[0], 10);
    if (num >= 3 && num <= 11) {
      return `Year ${num}`;
    }
    if (num === 12 || num === 14) {
      return "College (1st year)";
    }
    if (num === 13 || num === 15) {
      return "College (2nd year)";
    }
    if (num === 18) {
      return "Post-18";
    }
    if (num === 16) {
      return "Year 16";
    }
    return `Year ${num}`;
  }

  if (strYear) {
    return strYear;
  }

  return null;
};


